export default {
  getBEARER: (state) => state.BEARER,
}